const EMPTY_QUESTION_LABEL = 'Sin texto';
const IMAGE_ONLY_LABEL = '(Imagen)';

export function formatTestQuestionSidebarPreview(pregunta) {
  const text = (pregunta?.pregunta ?? '').trim();
  if (text) {
    return text;
  }
  if (pregunta?.imagenUrl) {
    return IMAGE_ONLY_LABEL;
  }
  return EMPTY_QUESTION_LABEL;
}

export function formatTestQuestionSidebarTitle(pregunta, index) {
  const preview = formatTestQuestionSidebarPreview(pregunta);
  return `Pregunta ${index + 1}: ${preview}`;
}
